var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1235_12511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 5.82617H5.33317C3.8665 5.82617 2.67984 7.02617 2.67984 8.49284L2.6665 24.4928C2.6665 25.9595 3.8665 27.1595 5.33317 27.1595H26.6665C28.1332 27.1595 29.3332 25.9595 29.3332 24.4928V8.49284C29.3332 7.02617 28.1332 5.82617 26.6665 5.82617ZM26.6665 11.1595L15.9998 17.8262L5.33317 11.1595V8.49284L15.9998 15.1595L26.6665 8.49284V11.1595Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1235_12511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.492676)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.52de6fee0b1203003e00048a5e185057.svg";
export { ForwardRef as ReactComponent };